import { SetUserSelectedState, StateAbbrExists } from 'Foundation/Common/StateHelper';
import { SetUserSelectedStatCode } from 'Foundation/StatCode/StatCodeHelper';
import { ISelectedStatCodeData } from 'Foundation/StatCode/StatModels';
import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { IUserData, IUserDataServer, UserDataObject } from './UserContextModels';

type UserAction =
  | { type: 'update'; userDataObject: IUserData }
  | { type: 'reset' }
  | { type: 'updatestate'; selectedState: string }
  | { type: 'updatestat'; selectedStatCodeData: ISelectedStatCodeData };
type UserProviderProps = { children: React.ReactNode };
const UserStateContext = createContext<
  { userData: IUserData | undefined; updateSelectedState: Function; updateSelectedStat: Function } | undefined
>(undefined);

function userReducer(state: IUserData | undefined, action: UserAction): IUserData | undefined {
  switch (action.type) {
    case 'update': {
      return action.userDataObject;
    }
    case 'updatestate': {
      if (state) {
        return {
          ...state,
          state: action.selectedState,
        };
      } else return undefined;
    }
    case 'updatestat': {
      if (state) {
        if (action.selectedStatCodeData) {
          return {
            ...state,
            selectedStatCodeData: action.selectedStatCodeData,
          };
        } else {
          return {
            ...state,
          };
        }
      }
      return undefined;
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
export function UserDataProvider({ children }: UserProviderProps) {
  // window.userData comes from the analytics component view where user data is set globally for access in react
  const winUserData = (window as any)?.userData as IUserDataServer;
  const [userData, dispatch] = useReducer(userReducer, undefined);
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (winUserData) {
      const userDataObject: IUserData = new UserDataObject(winUserData) as IUserData;
      dispatch({ type: 'update', userDataObject: userDataObject });
    }
    setShow(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function updateSelectedState(selectedState: string) {
    if (userData && StateAbbrExists(selectedState, userData.channel)) {
      dispatch({ type: 'updatestate', selectedState: selectedState });
      await SetUserSelectedState(selectedState.toUpperCase());
    }
  }
  async function updateSelectedStat(formattedSubStat: string) {
    if (userData) {
      const selectedStatCodeData = await SetUserSelectedStatCode(formattedSubStat);
      if (selectedStatCodeData) {
        dispatch({ type: 'updatestat', selectedStatCodeData: selectedStatCodeData });
      }
    }
  }
  const value = { userData, updateSelectedState, updateSelectedStat };
  if (!show) return null;
  return <UserStateContext.Provider value={value}>{children}</UserStateContext.Provider>;
}

export function useUserData() {
  const context = useContext(UserStateContext);
  if (context === undefined) {
    throw new Error('useUserData must be used within a UserDataProvider');
  }
  return context;
}

export function UserData(props: any) {
  const { userData } = useUserData();
  const [hidden] = useState(props.hidden);
  return <div style={hidden ? { display: 'none' } : {}}>{`The current userType is ${userData?.userType}`}</div>;
}
